<!--
- 报告列表
- author: wang.y
- 修改时间: 2019-10-08
- 修改内容：导航修改
-->
<template>
<div>
  <DataNavigation></DataNavigation>
  <div class="report-list index_content">
    <div class="list-l ivu-layout-sider">
      <div class="right_column">
        <div class="keyword-input">
          <Input search enter-button :placeholder="search_phd" v-model="search_ipt" @on-search="handleSearch" />
        </div>
        <div class="rigit_title">
          <span>筛选</span>
          <Dropdown trigger="click" placement="bottom-start" @on-visible-change="handleDropdown" @on-click="haddleScreenDropdown">
            <a href="javascript:void(0)">
              <span>{{screen_active}}</span>
              <Icon type="md-arrow-dropup" v-if="drop_val" />
              <Icon type="md-arrow-dropdown" v-else />
            </a>
            <DropdownMenu slot="list">
              <DropdownItem v-for="(item, sindex) in screen_dropdown" :name="item" :selected="screen_active == item" :key="sindex">{{item}}</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
        <div class="rigit_content">
          <div class="screen_ul">
            <div class="screen_li" v-show="screen_active === '全部' || screen_active === '报告类型'">
              <div class="screen_tle" @click="screen_tle.type_arr = !screen_tle.type_arr">
                <span>报告类型</span>
                <Icon type="md-add" v-if="!screen_tle.type_arr" />
                <Icon type="md-remove" v-else />
              </div>
              <div class="screen_cnt" v-show="screen_tle.type_arr">
                <Checkbox v-model="checkAll.type_arr" class="all_option" @on-change="handleCheckAll('type_arr')" :disabled="checkAll.type_arr">
                  <span>不限</span>
                </Checkbox>
                <CheckboxGroup v-model="params.type_arr" @on-change="handleChangeOption($event, 'type_arr')">
                  <Checkbox v-for="(item,index) in report_type" :label="item.id" :key="index" v-show="index < 10 || showAllTag">
                    <span>{{item.name}} <template v-if="typeNum.length">({{item.id | dealName(typeNum, 'category_id', 'num', '0')}})</template></span>
                  </Checkbox>
                </CheckboxGroup>
                <span class="more_sel" @click="showAllType = !showAllType" v-if="report_type && report_type.length > 10">
                  <template v-if="!showAllType">查看更多</template>
                  <template v-else>收起更多</template>
                </span>
              </div>
            </div>
            <div class="screen_li" v-show="screen_active === '全部' || screen_active === '报告领域'">
              <div class="screen_tle" @click="screen_tle.tag_arr = !screen_tle.tag_arr">
                <span>报告领域</span>
                <Icon type="md-add" v-if="!screen_tle.tag_arr" />
                <Icon type="md-remove" v-else />
              </div>
              <div class="screen_cnt" v-show="screen_tle.tag_arr">
                <ul class="scr_attention">
                  <CheckboxGroup v-model="params.tag_arr" @on-change="handleChangeOption($event, 'tag_arr')">
                    <li v-for="tItem in dynview_tag_type" :key="tItem.id">
                      <div class="scr_att_tle">
                        <Icon type="md-arrow-dropright" v-if="!screen_sec[tItem.id]" @click="haddleSecSel(tItem.id)" />
                        <Icon type="md-arrow-dropdown" v-else @click="haddleSecSel(tItem.id)" />
                        <span @click="haddleSecSel(tItem.id)">{{tItem.name}}</span>
                      </div>
                      <div class="scr_att_cnt" v-show="screen_sec[tItem.id]">
                        <Checkbox v-for="item in hot_tag_map" :label="item.id" :key="item.id" v-if="item.type_id === tItem.id">
                          <span>{{item.name}} <template v-if="tagNum.length">({{item.id | dealName(tagNum, 'id', 'num', '0')}})</template></span>
                        </Checkbox>
                      </div>
                    </li>
                  </CheckboxGroup>
                </ul>
              </div>
            </div>
            <div class="screen_li" v-show="screen_active === '全部' || screen_active === '价格'">
              <div class="screen_tle" @click="screen_tle.price = !screen_tle.price">
                <span>价格</span>
                <Icon type="md-add" v-if="!screen_tle.price" />
                <Icon type="md-remove" v-else />
              </div>
              <div class="screen_cnt" v-show="screen_tle.price">
                <RadioGroup v-model="params.price" vertical @on-change="clearGetList">
                  <Radio label=""><span>不限</span></Radio>
                  <Radio :label="0"><span>免费({{freeNum}})</span></Radio>
                  <Radio :label="1"><span>付费({{payNum}})</span></Radio>
                </RadioGroup>
              </div>
            </div>
            <div class="screen_li" v-show="screen_active === '全部' || screen_active === '时间'">
              <div class="screen_tle" @click="screen_tle.time = !screen_tle.time">
                <span>时间</span>
                <Icon type="md-add" v-if="!screen_tle.time" />
                <Icon type="md-remove" v-else />
              </div>
              <div class="screen_cnt" v-show="screen_tle.time">
                <RadioGroup v-model="selTime" vertical @on-change="handleChangeTime">
                  <Radio label=""><span>不限</span></Radio>
                  <Radio v-for="(item, index) in timeOption" :label="item" :key="index">
                    <span>{{item}} <template v-if="yearNum.length">({{item | dealName(yearNum, 'year', 'num', '0')}})</template></span>
                  </Radio>
                  <Radio label="zdy"><span>自定义</span></Radio>
                </RadioGroup>
                <div class="zdy_time" v-if="selTime == 'zdy'">
                  <DatePicker type="date" v-model="params.s_time" placeholder="开始时间" :options="startOptions" @on-change="clearGetList" :clearable="false"></DatePicker>
                  <DatePicker type="date" v-model="params.e_time" placeholder="结束时间" :options="endOptions" @on-change="clearGetList" :clearable="false"></DatePicker>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="list-r">
      <div class="sel_opt" v-if="haveOption && haveOption.length > 0">
        <div class="sel_tle">已选条件</div>
        <div class="sel_cnt">
          <span v-for="(item,index) in haveOption" :key="index" @click="handleCancelOption(item)">{{item.name}}
            <Icon type="md-close" />
          </span>
        </div>
        <div class="sel_clear">
          <span @click="handleClearOption"><i class="iconfont">&#xe63e;</i>清空筛选</span>
        </div>
      </div>
      <div class="list-header">
        <p>共{{total}}篇报告</p>
      </div>
      <div :class="{'list-content': true, 'load': list_loading}">
        <ul>
          <li v-for="item,index in report_list" :key="index">
            <div class="report-img" @click="goDetail(item)">
              <span class="report-type" v-if="filter.dealName(item.category_id, report_type) != '--'">{{item.category_id | dealName(report_type)}}</span>
              <img :src="item.logo_path | logo_show" />
            </div>
            <div class="report-info">
              <div class="report-title" @click="goDetail(item)">{{item.title}}</div>
              <div class="report-summary" @click="goDetail(item)">{{item.summary}}</div>
              <div class="report-dec">
                <div class="report-price">
                  <template v-if="item.price > 0"><span>￥</span>{{item.price}}</template>
                  <template v-else>免费</template>
                </div>
                <div class="report-src" v-if="item.src_author !== ''"><i class="iconfont">&#xe645;</i>{{item.src_author}}</div>
                <div class="report-time"><i class="iconfont">&#xe632;</i>{{item.publish_time | timeTrans}}</div>
                <div class="report-iconfont-group">
                  <i class="iconfont s active" title="取消收藏" v-if="item.is_collect" @click="cancelCollect('1', item.id, delCollectCb, index)">&#xe66f;</i>
                  <i class="iconfont s" title="收藏" v-if="!item.is_collect" @click="addCollect('1', item.id, addCollectCb, index)">&#xe66f;</i>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <Nothing v-if="total == 0 && !list_loading">
          <p>没有相关报告</p>
        </Nothing>
        <Spin fix v-if="list_loading">
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
      </div>
      <div class="list-bottom">
        <div class="page clear" v-if="total > 10">
          <Page :total="total" :page-size="10" class="page_list" show-total show-elevator :current="params.page" @on-change="handleChangePage" />
        </div>
      </div>
    </div>
    <Modal v-model="reportIndex" @on-visible-change="reportModalCancel" :footer-hide="true" width="458" class="page-modal">
      <img :src="$store.state.static_img_url + 'pic/model/report-upload-model.png'" />
      <p class="p1">亲，今日下载量已耗尽~</p>
      <p class="p2">成为VIP会员， 下载量不受限。</p>
      <router-link to="/buyVip" class="go-vip-btn">立即成为VIP会员</router-link>
    </Modal>
  </div>
</div>
</template>
<script>
import {
  reportList,
  getMeta,
  tagReportNum,
  reportNum,
  getNumOfreadReport
} from '../../service'
import {
  idxOf,
  remove,
  removeArrObj
} from 'js/findIndex'
import {
  userInfo
} from 'js/userInfo'
import filter from 'js/filter'
import {
  collect_mixin
} from 'js/collect_mixin'
import {
  left_scroll
} from 'js/left_scroll'
import { getAddPuv } from 'js/addPuv.js'
import DataNavigation from '../DataList/components/DataNavigation.vue'
import Nothing from '@/components/Nothing2.vue'

export default {
  mixins: [userInfo, collect_mixin, getAddPuv, left_scroll],
  inject: ['login'],
  components: {
    DataNavigation,
    Nothing
  },
  data() {
    const _that = this
    return {
      filter: filter,
      report_list: [],
      total: 0,
      params: {
        type_arr: [],
        price: '',
        year: '',
        s_time: '',
        e_time: '',
        tag_arr: [],
        keyword: '',
        user_key: '',
        page: 1
      },
      search_ipt: '',
      search_phd: '',
      screen_dropdown: ['全部', '报告类型', '报告领域', '价格', '时间'],
      screen_active: '全部',
      screen_tle: {
        type_arr: false,
        tag_arr: false,
        time: false,
        price: false
      },
      checkAll: {
        type_arr: true,
        tag_arr: true,
      },
      screen_sec: {},
      showAllType: false,
      //时间筛选 相关变量
      selTime: '',
      startOptions: {
        disabledDate(date) {
          if (_that.params.e_time) {
            return moment(_that.params.e_time).isBefore(date)
          } else {
            return false
          }
        }
      },
      endOptions: {
        disabledDate(date) {
          if (_that.params.s_time) {
            return moment(_that.params.s_time).isAfter(date)
          } else {
            return false
          }
        }
      },
      hot_tag_map: [],
      report_type: [],
      tagNum: [],
      yearNum: [],
      typeNum: [],
      payNum: [],
      freeNum: [],
      reportIndex: false,
      had_read_report: [],
      drop_val: false,
      list_loading: true
    }
  },
  computed: {
    haveOption() {
      let optionTag = [],
        optionKeyWord = [],
        optionYear = [],
        optionStart = [],
        opitonEnd = [],
        optionType = [],
        optionPrice = []

      this.params.tag_arr.map((a) => {
        optionTag.push({
          type: 'tag_arr',
          name: filter.dealName(a, this.hot_tag_map),
          value: a
        })
      })
      if (this.params.year != '' && this.selTime != 'zdy') {
        optionYear = {
          type: 'year',
          name: this.params.year,
          value: this.params.year
        }
      }
      if (this.params.s_time != '') {
        optionStart = {
          type: 's_time',
          name: '开始时间：' + filter.time_moment(this.params.s_time),
          value: this.params.s_time
        }
      }
      if (this.params.e_time != '') {
        opitonEnd = {
          type: 'e_time',
          name: '结束时间：' + filter.time_moment(this.params.e_time),
          value: this.params.e_time
        }
      }
      this.params.type_arr.map((a) => {
        optionType.push({
          type: 'type_arr',
          name: filter.dealName(a, this.report_type),
          value: a
        })
      })
      if (this.params.price !== '') {
        optionPrice = {
          type: 'price',
          name: this.params.price == 0 ? '免费' : '付费',
          value: this.params.price
        }
      }
      if (this.params.keyword !== '') {
        optionKeyWord = {
          type: 'keyword',
          name: this.params.keyword,
          value: this.params.keyword
        }
      }
      return [].concat(
        optionKeyWord,
        optionTag,
        optionYear,
        optionStart,
        opitonEnd,
        optionType,
        optionPrice
      )
    },
    timeOption() {
      let end_year = moment().format('YYYY') - 0,
        begin_year = 2015,
        arr = []
      for (var i = end_year; i > begin_year - 1; i--) {
        arr.push(i)
      }
      return arr
    },
    dynview_tag_type() {
      return this.$store.state.dynview_tag_type
    },
    req_url() {
      return this.$store.state.req_url
    },
    default_key() {
      let index = this.$store.state.datahotsearchkey.findIndex(a => a.position_id == '14'),
          key = ''
      if (index > -1) {
        key = this.$store.state.datahotsearchkey[index].name
      }
      return key
    }
  },
  methods: {
    /**
     * 按需获取元数据
     */
    async getMeta() {
      this.$store.state.dynview_tag_type.map((a) => {
        this.screen_sec[a.id] = false
      })
      let res = await getMeta({
        name: ['hot_tag_map', 'report_type']
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'hot_tag_map', res.meta.hot_tag_map)
        this.$set(this.$data, 'report_type', res.meta.report_type)
        let t_arr = []
        this.hot_tag_map.map((a) => {
          t_arr.push(a.id)
        })
        this.getTagNum(t_arr)
      } else {
        this.$Message.error(res.message)
      }
    },
    async getReportList() {
      this.list_loading = true
      this.params.user_key = this.user_key
      let res = await reportList(this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.list_loading = false
        this.$set(this.$data, 'report_list', res.res)
        if (this.params.page == 1) this.$set(this.$data, 'total', res.count)
      } else {
        this.$Message.error(res.message)
      }
    },
    goDetail(item) {
      if (this.user_key) {
        const {
          href
        } = this.$router.resolve({
          name: "ReportDetail",
          params: {
            uid: item.uid
          }
        })
        window.open(href, '_blank')
        // if (item.price > 0) {
        //   // this.$router.push({name: 'ReportDetail', params: {uid: item.uid}})
        //
        // } else {
        //   if (this.had_read_report.indexOf(item.id) == -1) {
        //     this.getNumOfreadReport(item.uid)
        //   } else {
        //     let q = JSON.stringify({
        //       user_key: this.user_key,
        //       uid: item.uid
        //     })
        //     window.open(this.req_url + '/dg/reportfile?query=' + q)
        //   }
        // }
      } else {
        this.login()
      }
    },
    /**
     * 统计用户查看的免费报告篇数
     */
    async getNumOfreadReport(uid) {
      let res = await getNumOfreadReport({
        user_key: this.user_key
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        if (res.res < 10 || this.isVIP) {
          let q = JSON.stringify({
            user_key: this.user_key,
            uid: uid
          })
          window.open(this.req_url + '/dg/reportfile?query=' + q)
        } else {
          this.reportIndex = true
        }
        this.had_read_report = res.report_ids
      } else {
        this.$Message.error(res.message)
      }
    },
    haddleScreenDropdown(name) {
      this.screen_active = name
    },
    handleChangePage(val) {
      this.params.page = val
      this.getReportList()
      $('html, body').animate({
        scrollTop: 0
      }, 200)
    },
    haddleType(item) {
      if (!this.list_loading) {
        _czc.push(['_trackEvent', '动脉橙首页快讯', '话题类型点击(' + item.name + ')'])

        let index = this.params.type.findIndex((a) => a == item.id)
        if (index > -1) {
          this.params.type.splice(index, 1)
        } else {
          this.params.type.push(item.id)
        }

        if (this.params.type.length > 0) {
          this.type_all = false
        } else {
          this.type_all = true
        }
        this.clearGetList()
      } else {
        this.$Message.loading("数据正在加载中，请勿重复操作！")
      }
    },
    handleCheckAll(typeName) {
      if (this.checkAll[typeName]) {
        this.params[typeName] = []
      }
      this.clearGetList()
    },
    clearGetList() {
      if (!this.list_loading) {
        this.params.page = 1
        this.getReportList()
      } else {
        this.$Message.loading("数据正在加载中，请勿重复操作！")
      }
    },
    /**
     * 条件筛选
     */
    handleChangeOption(arr, typeName) {
      if (!this.list_loading) {
        if (arr.length > 0) {
          this.checkAll[typeName] = false
        } else {
          this.checkAll[typeName] = true
        }
        this.clearGetList()
      } else {
        this.$Message.loading("数据正在加载中，请勿重复操作！")
      }
    },
    /**
     * 时间筛选
     */
    handleChangeTime(val) {
      if (!this.list_loading) {
        if (val == '' || val == 'zdy') {
          this.params.year = ''
          this.params.s_time = ''
          this.params.e_time = ''
        } else {
          this.params.year = val
          this.params.s_time = ''
          this.params.e_time = ''
        }
        this.clearGetList()
      } else {
        this.$Message.loading("数据正在加载中，请勿重复操作！")
      }
    },
    /**
     * 产业领域数量计算-投融资/并购
     */
    async getTagNum(t_arr) {
      if (t_arr.length == 0) {
        return
      }
      let res = await tagReportNum({
        tag_arr: t_arr
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'tagNum', res.res)
      } else {
        this.$Message.error(res.message)
      }
    },
    /**
     * 筛选个数
     */
    async getCount() {
      let res = await reportNum((error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'yearNum', res.year_num)
        this.$set(this.$data, 'typeNum', res.type_num)
        this.$set(this.$data, 'payNum', res.pay_num)
        this.$set(this.$data, 'freeNum', res.free_num)
      } else {
        this.$Message.error(res.message)
      }
    },
    haddleSecSel(item_id) {
      this.screen_sec[item_id] = !this.screen_sec[item_id]
      this.$forceUpdate()
    },
    /**
     * 点击已选择项取消事件
     */
    handleCancelOption(item) {
      if (!this.list_loading) {
        switch (item.type) {
          case 'year':
            this.params.year = ''
            this.selTime = ''
            break;
          case 's_time':
            this.params.s_time = ''
            break;
          case 'e_time':
            this.params.e_time = ''
            break;
          case 'price':
            this.params.price = ''
            break;
          case 'keyword':
            this.params.keyword = ''
            this.search_ipt = ''
            break;
          default:
            this.params[item.type].remove(item.value)
            if (this.params[item.type].length == 0) {
              this.checkAll[item.type] = true
            }
        }
        this.clearGetList()
      } else {
        this.$Message.loading("数据正在加载中，请勿重复操作！")
      }
    },
    /**
     * 清空已选择项
     */
    handleClearOption() {
      this.params = {
        type_arr: [],
        price: '',
        year: '',
        s_time: '',
        e_time: '',
        tag_arr: [],
        keyword: '',
        user_key: '',
        page: 1
      }
      this.search_ipt = ''
      this.selTime = ''
      this.clearGetList()
    },
    reportModalCancel(value) {
      this.reportIndex = value
    },
    handleDropdown(val) {
      this.drop_val = val
    },
    addCollectCb(index) {
      this.report_list[index].is_collect = 1
    },
    delCollectCb(index) {
      this.report_list[index].is_collect = 0
    },
    handleSearch(val) {
      if (!this.list_loading) {
        if (val) {
          this.params.keyword = val
          this.search_phd = val.length > 10 ? val.substr(0, 9).concat('...') : val
          let index = this.$store.state.datahotsearchkey.findIndex(a => a.position_id == '14')
          if (index > -1) {
            this.$store.state.datahotsearchkey[index].name = val
          }
          this.$store.commit('updateDatahotsearchkey', this.$store.state.datahotsearchkey)
        } else {
          this.search_ipt = this.default_key
          this.params.keyword = this.default_key
        }
        this.params.page = 1
        this.getReportList()
      } else {
        this.$Message.loading("数据正在加载中，请勿重复操作！")
      }
    }
  },
  created() {
    this.search_phd = this.default_key ? (this.default_key.length > 10 ? this.default_key.substr(0, 9).concat('...') : this.default_key) : '请输入关键字'

    if (this.$store.state.report_params != '') {
      this.params = { ...this.$store.state.report_params }
      this.params.page = 1
      this.sort_id = this.params.sort_type
    }
    this.getMeta()
    this.getReportList()
    this.getCount()
    let url = window.location.href
    this.getAddPuv(url)
  },
  mounted() {
    this.$nextTick(() => {
      window.onscroll = () => {
        this.listenerScroll('right_column', 20)
      }
      window.onresize = () => {
        this.listenerScroll('right_column', 20)
      }
    })
  },
  destroyed() {
    window.onscroll = ''
    window.onresize = ''
  },
  beforeDestroy() {
    this.$store.commit('updateReportParams', this.params)
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/rightColumn.stylus'
@import '~styles/report.stylus'
</style>
